import React, { useEffect, useRef, useState } from "react";
import { FaCheck, FaCopy, FaDownload, FaEnvelope, FaShareAlt, FaTimes, FaWhatsapp } from "react-icons/fa";
import QRCode from "qrcode";
import "./CourseVideoShare.css";

export default function CourseVideoShare({ course, onClose }) {
  const [qrImage, setQrImage] = useState("");
  const [qrError, setQrError] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");
  const dialogRef = useRef(null);
  const link = new URL("/pengembangandiri", window.location.origin);
  link.searchParams.set("tab", "kursus");
  link.searchParams.set("video", String(course.id));
  const shareUrl = link.toString();
  const shareText = `${course.title} - Sahabat Kakao`;

  useEffect(() => {
    let active = true;
    QRCode.toDataURL(shareUrl, { width: 256, margin: 4, errorCorrectionLevel: "M" })
      .then((url) => { if (active) setQrImage(url); })
      .catch(() => { if (active) setQrError(true); });
    return () => { active = false; };
  }, [shareUrl]);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.querySelector("button")?.focus();
    const handleKey = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key !== "Tab") return;
      const elements = dialogRef.current?.querySelectorAll("button:not(:disabled), a[href], input");
      if (!elements?.length) return;
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKey);
      previousFocus?.focus();
    };
  }, [onClose]);

  const copyLink = async () => {
    setError("");
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        const input = dialogRef.current?.querySelector("input");
        input.focus();
        input.select();
        if (!document.execCommand("copy")) throw new Error("Copy failed");
      }
      setCopied(true);
    } catch {
      setError("Tautan belum tersalin. Pilih tautan untuk menyalinnya secara manual.");
    }
  };

  const shareOther = async () => {
    setError("");
    try {
      await navigator.share({ title: course.title, text: shareText, url: shareUrl });
    } catch (shareError) {
      if (shareError.name !== "AbortError") setError("Berbagi belum berhasil. Gunakan WhatsApp atau salin tautan.");
    }
  };

  return (
    <div className="course-share-overlay" onClick={onClose}>
      <section ref={dialogRef} className="course-share-dialog" role="dialog" aria-modal="true" aria-labelledby="course-share-title" onClick={(event) => event.stopPropagation()}>
        <header>
          <div><h3 id="course-share-title">Bagikan Video</h3><p>{course.title}</p></div>
          <button type="button" className="course-share-close" onClick={onClose} aria-label="Tutup bagikan video" title="Tutup"><FaTimes aria-hidden="true" /></button>
        </header>
        <div className="course-share-body">
          <div className="course-share-options">
            <a className="course-share-option whatsapp" href={`https://wa.me/?text=${encodeURIComponent(`${shareText}\n${shareUrl}`)}`} target="_blank" rel="noopener noreferrer"><FaWhatsapp aria-hidden="true" /> WhatsApp</a>
            <a className="course-share-option" href={`mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(shareUrl)}`}><FaEnvelope aria-hidden="true" /> Email</a>
            {typeof navigator.share === "function" && <button type="button" className="course-share-option" onClick={shareOther}><FaShareAlt aria-hidden="true" /> Lainnya</button>}
          </div>
          <div className="course-share-link">
            <input aria-label="Tautan video" readOnly value={shareUrl} onFocus={(event) => event.target.select()} />
            <button type="button" onClick={copyLink} title={copied ? "Tautan tersalin" : "Salin tautan"} aria-label={copied ? "Tautan tersalin" : "Salin tautan"}>{copied ? <FaCheck aria-hidden="true" /> : <FaCopy aria-hidden="true" />}</button>
          </div>
          <div className="course-share-feedback" role="status">{error || (copied ? "Tautan berhasil disalin." : "")}</div>
          <div className="course-share-qr">
            <h4>QR Code</h4>
            <div className="course-share-qr-image">
              {qrImage ? <img src={qrImage} alt={`QR code video ${course.title}`} width="256" height="256" /> : <span role="status">{qrError ? "QR code gagal dibuat." : "Menyiapkan QR code..."}</span>}
            </div>
            {qrImage && <a href={qrImage} download={`sahabat-kakao-video-${course.id}.png`} className="course-share-option"><FaDownload aria-hidden="true" /> Unduh QR Code</a>}
          </div>
        </div>
      </section>
    </div>
  );
}
